.root {
  border: 1px solid var(--border-color);
  border-radius: 1px;
  overflow: hidden;
}

/* Reset margin for p tag that was set by a parent element */
.root p {
  margin: 0;
}